type Question = {
  description: string
  labels: string[]
  q: string[]
  values: number[]
  reversed: number[]
  getScore: (inputs: number[]) => number | null
}

export const PSS: Question = {
  description:
    '다음 문항들은 지난 한 달 동안의 당신의 감정과 생각에 관하여 물어보는 것입니다. 각 문항들을 주의 깊게 읽고, 얼마나 자주 그렇게 느끼고 생각하는지 해당되는 부분에 표시 하여 주십시오. ',
  labels: [
    '전혀 없었다',
    '거의 없었다',
    '가끔 있었다',
    '자주 있었다',
    '매우 자주 있었다',
  ],
  q: [
    '예상치 못한 일 때문에 화가 났다.',
    '나의 삶에서 중요한 일들을 통제할 수 없다고 느꼈다.',
    '신경이 예민해지고 스트레스를 받았다.',
    '나의 개인적인 문제들을 다루는 능력에 대해 자신감이 느껴졌다.',
    '내 방식대로 일이 진행되고 있다고 느꼈다.',
    '내가 해야만 하는 일들 모두에 대처할 수 없다고 생각되었다.',
    '일생생활에서 겪는 불안감과 초조함을 통제할 수 있었다.',
    '어떤 일을 아주 잘했다고 생각했다.',
    '내가 통제할 수 없는 일 때문에 화가 났다.',
    '힘든 일이 너무 많이 쌓여서 극복할 수 없다고 느꼈다.',
  ],
  values: [0, 1, 2, 3, 4],
  reversed: [4, 5, 7, 8],
  getScore (inputs) {
    if (inputs.length !== this.q.length) return null

    let val = 0
    for (let i = 0; i < inputs.length; i++) {
      if (inputs[i] === undefined) return null

      if (this.reversed.includes(i + 1)) {
        val += this.values.at(-1 - inputs[i])
      } else {
        val += this.values.at(inputs[i])
      }
    }

    return val
  },
}

export const 스키마검사: Question = {
  description:
    '다음 문장들을 읽어보시고 자신을 얼마나 잘 나타내는지 체크해주세요. 꼭 확신이 서지 않아도 나와 느낌이 비슷한 정도에 체크해 주시면 됩니다. 일부 문항은 부모님(주양육자)과의 관계에 대한 것입니다. 돌아가신 분이 계시다면 생전의 관계를 떠올려보고 대답해주세요',
  labels: [
    '전혀 아니다',
    '별로 아니다',
    '어느 쪽도 아니다',
    '다소 그렇다',
    '매우 그렇다',
  ],
  q: [
    '나의 진짜 모습을 아는 사람들은 나를 좋아하지 않을 거예요.',
    '나는 남들이 보기에 부자연스러운 면이 있어요.',
    '나는 곤란한 일들을 혼자 헤쳐 나갈 능력이 부족한 것 같아요.',
    '안 좋은 일이 일어날 것만 같은 느낌을 자주 받아요.',
    '사람들은 나를 다혈질이라고 생각할 것 같아요.',
    '주로 내가 주변 사람들을 챙기는 역할을 해요.',
    '무엇을 하든 내가 생각하는 기준을 만족하지 않으면, 마음이 편치 않아요.',
    '일이 잘 되어가는 것 같아도, 언제 잘못 될지 모른다는 걱정이 들어요.',
    '나는 사소한 일에도 화가 치밀어 오르는 편이에요.',
    '나는 사람들이 좋아할 만한 사람이 아니에요.',
    '나는 타고나기를 남들과는 다르다는 느낌이 들어요.',
    '주변 사람들은 내가 걱정이 많다고 생각할 것 같아요.',
    '내가 좋아하지 않는 사람조차도 나를 좋아해주기를 바라요.',
    '“이 정도면 됐다”는 수준에 만족하고 타협하는 게 잘 안돼요.',
    '작은 일도 크게 걱정하는 편이에요.',
    '뜻대로 안될 때 욱하는 감정을 참기 어려워요.',
    '나의 실제 모습을 숨기고 싶어요.',
    '내가 바라는 것을 주장하면 마음이 매우 불편해져요.',
    '나는 어디에도 소속되었다는 느낌이 잘 안들어요.',
    '나는 남들에 비해서 아는 게 부족한 것 같아요.',
    '상대방의 기분과 의견에 맞추느라, 나의 기분과 마음을 잘 돌보지 못해요.',
    '나의 기준은 대부분의 다른 사람들보다 더 높은 것 같아요.',
    '나는 쉽게 흥분하는 편이에요.',
    '누군가와 가까워지면 상처받을까 두려워요.',
    '사람들 사이에 있어도 외로움을 느껴요.',
    '다른 사람들이 나를 좋아하지 않을까봐 자꾸 신경 쓰여요.',
    '나는 무언가를 더 이루고 해내야 한다는 압박감이 있어요.',
    '화났을 때 생각보다 행동이 앞서서 뒤늦게 후회해요.',
    '나는 어떤 모임에서도 주변인 같고, 혼자라는 느낌이에요.',
    '무언가를 책임져야 하는 상황이 두려워요',
    '화로 인해서, 대인관계나 중요한 일을 망친 적이 있어요.',
    '다른 사람의 부탁이나 요구를 거절하지 못하는 편이에요.',
    '나는 내 실수에 관대하지 않아요.',
    '나는 선택을 잘못해서 나쁜 결과가 생길까봐 걱정돼요.',
    '사람들과 어떻게 어울려야 할지 모르겠어요.',
  ],
  values: [1, 2, 3, 4, 5],
  reversed: [],
  getScore (inputs) {
    if (inputs.length !== this.q.length) return null

    let val = 0
    for (let i = 0; i < inputs.length; i++) {
      if (inputs[i] === undefined) return null

      if (this.reversed.includes(i + 1)) {
        val += this.values.at(-1 - inputs[i])
      } else {
        val += this.values.at(inputs[i])
      }
    }

    return val
  },
}

export const HMPS: Question = {
  description:
    '다음 제시되는 질문들을 자세히 읽어보신 후, 자신이 얼마나 동의하는지를 나타내는 부분에 표시 하십시오.',
  labels: [
    '전혀 그렇지 않다',
    '대체로 그렇지 않다',
    '약간 그렇지 않다',
    '보통이다',
    '약간 그렇다',
    '대체로 그렇다',
    '아주 그렇다',
  ],
  q: [
    '일단 일을 시작하고 나면, 다 끝마칠 때까지는 쉬지 않는다.',
    '다른 사람이 일을 너무 쉽게 포기하는 것을 봐도 비난하지 않는다.',
    '친한 사람이 성공하는 것은 그리 중요한 일이 아니다.',
    '친구가 최선이 아닌 선택을 해도 비난하지 않는다.',
    '남이 내게 기대하는 것을 맞추기가 어렵다.',
    '나의 목표는 모든 일에서 완벽해지는 것이다.',
    '다른 사람들이 하는 모든 일은 최고의 것이어야 한다.',
    '일을 하면서 완벽을 기하지 않는다.',
    '주위 사람들은 내가 실수를 할 수도 있다고 생각한다.',
    '주위 사람들이 최선을 다하지 않는 것을 봐도 나는 별로 문제 삼지 않는다.',
    '내가 일을 잘 할수록 사람들은 더 잘 할 것으로 기대한다.',
    '나는 완벽해지고자 하는 욕구가 거의 없다.',
    '내가 하는 일이 최고가 아니라면 사람들은 나를 형편없게 볼 것이다.',
    '나는 가능한 한 완벽하려고 애쓴다.',
    '모든 일을 완벽하게 하는 것이 나에게는 매우 중요한 일이다.',
    '나에게 중요한 사람들에게 큰 기대를 한다.',
    '내가 하는 모든 일에서 최선을 다한다.',
    '주변 사람들은 내가 모든 일에서 성공하기를 기대한다.',
    '주위 사람들에 대해 높은 기준을 가지고 있지는 않다.',
    '나 자신이 완벽하기를 바란다.',
    '내가 모든 일을 다 잘하지 않더라도 사람들은 나를 좋아할 것이다.',
    '더 나아지려고 노력하지 않는 사람들을 보면 참을 수가 없다.',
    '내가 한 실수를 발견하게 되면 매우 속이 상한다.',
    '친구들에게 많은 것을 기대하지 않는다.',
    '성공이란 다른 사람을 기쁘게 하기 위해서 더욱 열심히 일을 해야만 한다는 것이다.',
    '내가 누군가에게 일을 부탁한 경우, 그 일이 완벽하게 되어있기를 기대한다.',
    '나와 가까운 사람들이 실수하는 것을 참을 수가 없다.',
    '나는 목표를 완벽하게 세우려고 한다.',
    '내게 중요한 사람들은 결코 나를 실망시켜서는 안 된다.',
    '내가 성공하지 못하더라도 사람들은 나를 괜찮은 사람으로 생각한다.',
    '나는 사람들이 내게 너무 많은 요구를 한다고 생각한다.',
    '나는 일을 하는 데 항상 최선을 다해야 한다.',
    '내가 실수했을 때 사람들은 비록 나타내지는 않지만 매우 실망할 것이다.',
    '내가 하는 모든 일에서 최고일 필요는 없다.',
    '나의 가족은 내가 완벽하기를 기대한다.',
    '나 자신에게 매우 높은 목표를 세우지 않는다.',
    '부모님은 내가 하는 모든 일에서 뛰어나기를 기대하지는 않는다.',
    '나는 평범한 사람을 존경한다.',
    '사람들은 나에게서 완벽함을 기대한다.',
    '나 자신에게 높은 기준을 부여한다.',
    '사람들은 내가 할 수 있는 것보다 많은 것을 기대한다.',
    '나는 학업에서나 일에서나 항상 성공해야만 한다.',
    '친한 친구가 최선을 다하지 않아도 내게는 그리 문제가 되지 않는다.',
    '내 주위 사람들은 내가 실수를 할 경우에도 여전히 나를 유능하다고 생각한다.',
    '나는 다른 사람들이 모든 일을 잘 할 것이라고는 기대하지 않는다.',
  ],
  values: [1, 2, 3, 4, 5, 6, 7],
  reversed: [2, 3, 4, 8, 9, 10, 12, 19, 21, 24, 30, 34, 36, 37, 38, 43, 44, 45],
  getScore (inputs) {
    if (inputs.length !== this.q.length) return null

    let val = 0
    for (let i = 0; i < inputs.length; i++) {
      if (inputs[i] === undefined) return null

      if (this.reversed.includes(i + 1)) {
        val += this.values.at(-1 - inputs[i])
      } else {
        val += this.values.at(inputs[i])
      }
    }

    return val
  },
}

export const BAI: Question = {
  description:
    '아래의 항목들은 불안의 일반적 증상들을 열거한 것입니다. 먼저 각 항목을 주의깊게 읽으십시오. 오늘을 포함해서 지난 한 주 동안 귀하가 경험한 증상의 정도를 아래와 같이 그 정도에 따라 적당한 숫자에 체크해 주십시오.',
  labels: ['전혀 안느낌', '조금 느낌', '상당히 느낌', '심하게 느낌'],
  q: [
    '나는 가끔씩 몸이 저리고 쑤시며 감각이 마비된 느낌을 받는다.',
    '나는 흥분된 느낌을 받는다.',
    '나는 가끔씩 다리가 떨리곤 한다.',
    '나는 편안하게 쉴 수가 없다.',
    '매우 나쁜 일이 일어 날 것 같은 두려움을 느낀다.',
    '나는 어지러움(현기증)을 느낀다.',
    '나는 가끔씩 심장이 두근거리고 빨리 뛴다.',
    '나는 침착하지 못하다.',
    '나는 자주 겁을 먹고 무서움을 느낀다.',
    '나는 신경이 과민되어 있다.',
    '나는 가끔씩 숨이 막히고 질식할 것 같다.',
    '나는 자주 손이 떨린다.',
    '나는 안절부절 못 해 한다.',
    '나는 미칠 것 같은 두려움을 느낀다.',
    '나는 가끔씩 숨쉬기가 곤란할 때가 있다.',
    '나는 죽을 것 같은 두려움을 느낀다.',
    '나는 불안한 상태에 있다.',
    '나는 자주 소화가 잘 안되고 뱃속이 불편하다.',
    '나는 가끔씩 기절할 것 같다.',
    '나는 자주 얼굴이 붉어지곤 한다.',
    '나는 땀을 많이 흘린다(더위로 인한 경우는 제외).',
  ],
  values: [0, 1, 2, 3],
  reversed: [],
  getScore (inputs) {
    if (inputs.length !== this.q.length) return null

    let val = 0
    for (let i = 0; i < inputs.length; i++) {
      if (inputs[i] === undefined) return null

      if (this.reversed.includes(i + 1)) {
        val += this.values.at(-1 - inputs[i])
      } else {
        val += this.values.at(inputs[i])
      }
    }

    return val
  },
}

export const K_SSES: Question = {
  description:
    "아래 문항의 내용에 대해 '지금 이 순간', 당신이 느끼는 정도에 따라서 해당되는 부분에 표시해주시기 바랍니다. 자유롭고 솔직하게 응답해주시기 바랍니다.",
  labels: [
    '전혀 아니다',
    '아주 약간 그렇다',
    '다소 그렇다',
    '많이 그렇다',
    '아주 많이 그렇다',
  ],
  q: [
    '나는 내 능력에 대해 자신이 있다고 느낀다.',
    '나는 내가 성공한 이로 여겨질지, 실패한 이로 여겨질지 걱정한다.',
    '나는 지금 내 몸매가 만족스럽다고 느낀다.',
    '나는 내 수행에 대해 좌절스럽거나 당황스럽게 느낀다.',
    '나는 내가 읽은 것을 이해하는 데 어려움이 있다고 느낀다.',
    '나는 다른 이들이 나를 존경하거나 존중한다고 느낀다.',
    '나는 내 체중이 불만족스럽다.',
    '나는 남의 시선을 의식한다.',
    '나는 다른 이들만큼 영리하다고 느낀다.',
    '나는 나 자신이 못마땅하다고 느낀다.',
    '나는 나 자신에 대해 좋다고 느낀다.',
    '나는 지금 내 외모에 흡족해한다.',
    '나는 다른 사람들이 나를 어떻게 생각하는 지에 대해 걱정한다.',
    '나는 일들을 이해하는 데 자신감을 느낀다.',
    '나는 지금 이 순간 다른 사람들에 비해 열등하다고 느낀다.',
    '나는 매력이 없다고 느낀다.',
    '나는 내 인상에 대해 염려한다.',
    '나는 지금 이 순간, 다른 이들보다 학업능력이 부족하다고 느낀다.',
    '나는 내가 일을 잘하고 있지 않은 것 같다고 느낀다.',
    '나는 바보같이 보일까봐 걱정한다.',
  ],
  values: [1, 2, 3, 4, 5],
  reversed: [2, 4, 5, 7, 8, 10, 13, 15, 16, 17, 18, 19, 20],
  getScore (inputs) {
    if (inputs.length !== this.q.length) return null

    let val = 0
    for (let i = 0; i < inputs.length; i++) {
      if (inputs[i] === undefined) return null

      if (this.reversed.includes(i + 1)) {
        val += this.values.at(-1 - inputs[i])
      } else {
        val += this.values.at(inputs[i])
      }
    }

    return val
  },
}

export const UCLA: Question = {
  description:
    '다음 문장을 읽고 여러분이 일상생활에서 얼마나 자주 이와 같이 느끼는지에 대해 아래의 네 가지 중 하나에 표시를 해주십시오.',
  labels: ['전혀 느끼지 않음', '별로 느끼지 않음', '약간 느낌', '자주 느낌'],
  q: [
    '나는 내 주변의 사람들과 잘 어울린다.',
    '나는 함께 해 줄 친구가 없다.',
    '내가 의지할 수 있는 사람이 없다.',
    '나는 외롭지 않다고 느낀다.',
    '나는 친구들 집단에 소속감을 느낀다.',
    '나는 내 주변의 사람들과 공통점이 많다.',
    '나는 이제 어느 누구와도 가깝지 않다.',
    '나의 관심과 생각이 주위 사람들과 같지 않다.',
    '나는 외향적인 사람이다.',
    '나는 주위에 가깝게 느끼는 사람들이 있다.',
    '나는 버려진 듯한 느낌이다.',
    '나의 대인관계는 피상적이다.',
    '나를 진정으로 아는 사람은 아무도 없다.',
    '나는 남들로부터 소외된 느낌이다.',
    '나는 내가 원할 때 함께 해 줄 친구가 있다.',
    '나를 진정으로 이해해 주는 사람들이 있다.',
    '나는 너무 다른 사람에게 가까이 가지 못해서 불행하다.',
    '내 주위에 사람들이 있기는 한데, 그들이 진정으로 나와 함께 해주지는 않는다.',
    '나는 대화를 나눌 수 있는 사람이 있다.',
    '내가 의지할 수 있는 사람이 있다.',
  ],
  values: [1, 2, 3, 4],
  reversed: [1, 4, 5, 6, 9, 10, 15, 16, 19, 20],
  getScore (inputs) {
    if (inputs.length !== this.q.length) return null

    let val = 0
    for (let i = 0; i < inputs.length; i++) {
      if (inputs[i] === undefined) return null

      if (this.reversed.includes(i + 1)) {
        val += this.values.at(-1 - inputs[i])
      } else {
        val += this.values.at(inputs[i])
      }
    }

    return val
  },
}
